// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const DocumentInventory = reactLazyRetry(
  () => import('./pages/DocumentInventory')
);

/**
 * Document Inventory route definitions and metadata used by the application
 * router and permission-aware navigation (QuickLinks).
 */
export const documentRoutes = [
  {
    name: 'Document Inventory',
    key: 'DocumentInventory',
    path: DEFAULT_ROUTE_CONFIG?.documentInventory?.path || 'document-inventory',
    element: <DocumentInventory />,
    permission: 'DocumentInventory_documentInventory',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
];
